<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-xs-left title-breadcrumb">
				<div><router-link class="font-weight-regular subheading" :to="{ name: 'assets' }" >Assets</router-link></div>
				<span class="subheading"><v-icon>chevron_right</v-icon> </span>
				<div class="subheading font-weight-bold">{{ asset.name  }}</div>
				<v-chip :color="assetStatusColor" dark small> {{ asset.status }}</v-chip>
			</div>

			<div class="action-btn-group">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn :small="!$vuetify.breakpoint.smAndUp" color="primary" dark v-on="on"> Actions<v-icon class="ml-1">mdi-chevron-down</v-icon> </v-btn>
					</template>
					<v-list>
						<v-list-tile v-if="!asset.assignedTo && asset.status.toLowerCase() !== 'retired'" @click="$emit('assign')">
							<v-list-tile-action><v-icon>person_add</v-icon></v-list-tile-action>
							<v-list-tile-title>Assign</v-list-tile-title>
						</v-list-tile>
						<v-list-tile v-if="asset.assignedTo" @click="$emit('unassign')">
							<v-list-tile-action><v-icon>mdi-account-off</v-icon></v-list-tile-action>
							<v-list-tile-title>Unassign</v-list-tile-title>
						</v-list-tile>
						<v-list-tile @click="$emit('duplicate')">
							<v-list-tile-action><v-icon>content_copy</v-icon></v-list-tile-action>
							<v-list-tile-title>Duplicate</v-list-tile-title>
						</v-list-tile>
						<v-list-tile v-if="!asset.assignedTo && asset.status.toLowerCase() !== 'retired'" @click="$emit('retire')">
							<v-list-tile-action><v-icon>mdi-cancel</v-icon></v-list-tile-action>
							<v-list-tile-title>Retire</v-list-tile-title>
						</v-list-tile>
						<v-list-tile v-if="asset.status.toLowerCase() === 'retired'" @click="$emit('activate')">
							<v-list-tile-action><v-icon>mdi-backup-restore</v-icon></v-list-tile-action>
							<v-list-tile-title>Un-retire</v-list-tile-title>
						</v-list-tile>
						<!-- <v-list-tile @click="$emit('service')">
							<v-list-tile-action><v-icon>build</v-icon></v-list-tile-action>
							<v-list-tile-title>Record Service</v-list-tile-title>
						</v-list-tile> -->
						<v-list-tile v-if="!asset.assignedTo" @click="$emit('delete')">
							<v-list-tile-action><v-icon>delete</v-icon></v-list-tile-action>
							<v-list-tile-title>Delete</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</div>
		<v-divider class="mt-2" />
	</div>
</template>

<script>
	export default {
		name: 'AssetDetailsHeader',
		props: {
			asset: {
				type: Object,
				required: true
			}
		},
		computed: {
			assetStatusColor() {
				switch (this.asset.status.toLowerCase()) {
					case 'available':
						return 'success';
					case 'assigned':
						return 'indigo';
					case 'retired':
						return 'warning';
					case 'deleted':
						return 'error';
				}
			},
		}
	};
</script>

<style scoped>
	.action-btn-group {
		display: flex;
		justify-content: flex-end;
	}

	.title-breadcrumb {
		display: flex;
		align-items: center;
		gap: 5px;
	}
</style>
